export enum SantanderSuitabilityEnum {
  semPerfil = 'SEM PERFIL',
  CONSERVADOR = 'CONSERVADOR',
  BALANCEADO = 'BALANCEADO',
  MODERADO = 'MODERADO',
  ARROJADO = 'ARROJADO',
  AGRESSIVO = 'AGRESSIVO',
}

export function getSantanderEnumFromString(profileValue: string): SantanderSuitabilityEnum {
  const enumKeys = Object.keys(SantanderSuitabilityEnum);
  const foundKey = enumKeys.find(key => SantanderSuitabilityEnum[key] === profileValue.trim().toUpperCase());
  return foundKey ? SantanderSuitabilityEnum[foundKey] : SantanderSuitabilityEnum.semPerfil;
}
